import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const WhiteboardRouteComponentLoader: LoadableType<{
	spaceKey: string;
	contentId: string;
}> = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-WhiteboardRouteComponent" */ './WhiteboardRouteComponent.tsx'
		),
});
